import { ConverterAnalyticsEventType } from '@quicktools/shared-components/services/converter-analytics';
import { AnalyticsGTM } from '@quicktools/shared-components/services/analytics-gtm';
import ReactGA4 from 'react-ga4';

import { VERSION, TOOL_NAME } from '../../configs';

const page_name = 'main';

class Analytics extends AnalyticsGTM {
  event(action: string) {
    this.sendGaEvent(action, {
      page_name,
    });
    this.hjEvent(action);
  }

  pageOpen() {
    this.sendGaEvent(ConverterAnalyticsEventType.PAGE_OPEN, {
      page_name,
      non_interaction: true,
    });
  }

  fontCopy(action_type: string, font_name: string, position: number) {
    this.sendGaEvent('font_copy', {
      page_name,
      action_type,
      font_name,
      position,
    });
    this.sendBrazeEvent('font_copy');
  }

  moreFontsLoaded(load_numbers: string) {
    this.sendGaEvent('more_fonts_loaded', {
      page_name,
      load_numbers,
    });
  }

  fontArrayCopy(character_information: string) {
    this.sendGaEvent('font_array_copy', {
      page_name,
      character_information,
    });
  }
  pageClick(params) {
    this.sendGaEvent('page_click', { ...params });
  }
}

export default new Analytics(
  {
    VERSION,
    TOOL_NAME,
  },
  ReactGA4,
);
